import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22utils.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/BalooBhai-Regular.ttf%22,%22variable%22:%22--font-BalooBhai-Regular%22}],%22variableName%22:%22BalooBhaifont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'BalooBhaifont', 'BalooBhaifont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
